import React from 'react';

/** Short patient-facing summary of clinic booking rules. */
export default function BookingConfigNote({ config }) {
  if (!config) return <div className="mb-4" />;
  const prior = Number(config.patient_book_hours_prior || 0);
  return (
    <p className="text-[11px] text-zinc-400 mb-4" data-testid="booking-config-note">
      {prior > 0
        ? `Future days: book at least ${prior}h ahead · same-day open slots stay available`
        : 'Same-day and future open slots are available'}
      {config.patient_cancel_hours_prior != null
        ? ` · cancel up to ${config.patient_cancel_hours_prior}h before`
        : ''}
      {config.booking_mode === 'daily_count'
        ? ' · daily appointment quota'
        : ` · ${config.slot_minutes}-min slots`}
      .
    </p>
  );
}
